import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import {
  adminSetPoliciesAction,
  policiesSelector,
  PolicyControlView,
  rebuildPolicies,
} from 'pages/administration.page';
import { policyModel } from 'common/api/models';

/**
 * @param {policyModel} policy
 */
class PolicyControl extends React.Component {
  state = {
    showEditForm: false,
  };

  static propTypes = {
    policy: PropTypes.objectOf(policyModel),
  };

  onDelete = (e) => {
    e.preventDefault();

    const newPolicies = rebuildPolicies(this.props.policies, {
      id: this.props.policy.id,
      organizationGroup: null,
      permissions: null,
    });

    this.props.dispatch(adminSetPoliciesAction(newPolicies));
  };

  onEdit = (e) => {
    e.preventDefault();
    this.toggleEdit();
    const newPolicyName = e.target.elements.namedItem('policy-name').value;

    const newPolicies = rebuildPolicies(this.props.policies, {
      ...this.props.policy,
      organizationGroup: newPolicyName,
    });

    this.props.dispatch(adminSetPoliciesAction(newPolicies));
  };

  toggleEdit = () => this.setState({ showEditForm: !this.state.showEditForm });

  render() {
    return (
      <PolicyControlView
        policy={this.props.policy}
        showEditForm={this.state.showEditForm}
        toggleEdit={this.toggleEdit}
        onEdit={this.onEdit}
        onDelete={this.onDelete}
      >
        {this.props.children}
      </PolicyControlView>
    );
  }
}

const mapStateToProps = (state) => ({
  policies: policiesSelector(state),
});

export const PolicyControlDecorated = connect(mapStateToProps, (dispatch) => ({ dispatch }))(PolicyControl);
